export var FreezeMode;
(function (FreezeMode) {
    FreezeMode["NONE"] = "none";
    FreezeMode["SHALLOW"] = "shallow";
    FreezeMode["DEEP"] = "deep";
})(FreezeMode || (FreezeMode = {}));
export class ChatAreaPlugin {
    constructor(context) {
        this.Context = context;
    }
}
export * from './query.js';
